import { PermissionType } from 'services/permissions';
import { GlobalSettings } from 'services/commerce/settings';
import React from 'react';

export interface RowDescriptorBase {
  title: string;
  field?: string;
  textbox?: boolean;
  meta?: any;
  dataQa?: string;
  disabled?: boolean;
}

// Types for RowDescriptor
export interface TextDescriptor extends RowDescriptorBase {
  type: RowType.Text;
  handleShowTextAsBoolean?(
    value: string,
    field: string,
    setCardData: (field: string, value: string) => void
  ): void;
}

export interface TagDescriptor extends RowDescriptorBase {
  type: RowType.Tag;
}

export interface MappingDescriptor<T = any> extends RowDescriptorBase {
  type: RowType.Mapping;
  options: T[];
  isFieldDisabled?(option: T): boolean;
  getOptionsLabel?(option: T): string;
  isOptionEqualToValue?(option: T, value: T): boolean;
  handleAutocompleteChange?(
    e: React.ChangeEvent<{}>,
    value: T,
    field: string,
    setCardData: (field: string, value: unknown) => void
  ): void;
}

export interface LocationPickerDescriptor extends RowDescriptorBase {
  type: RowType.LocationPicker;
}

export interface CardData extends GlobalSettings {
  [key: string]: any;
}

export type RowDescriptor =
  | TextDescriptor
  | LocationPickerDescriptor
  | MappingDescriptor
  | TagDescriptor;

export enum RowType {
  'Text' = 'text',
  'LocationPicker' = 'locationPicker',
  'Mapping' = 'mapping',
  'Tag' = 'tag',
}

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  data: CardData | undefined;
  onApplyClicked(newData: unknown): void;
  rows: RowDescriptor[];
  id?: string;
  show: boolean;
  viewPermissions?: PermissionType[];
  editPermissions?: PermissionType[];
  dataQa?: string;
  cardDataLoaded: boolean;
  setTagsLoaded?: React.Dispatch<React.SetStateAction<boolean>>;
  setLocationsLoaded?: React.Dispatch<React.SetStateAction<boolean>>;
}
